module.exports = __webpack_public_path__ + "img/zyncro-logo.a03ef698.svg";